<template>
  <div class="dropzone" :id="id">
    <div v-if="!!error" class="alert alert-danger">{{ error }}</div>
    <div class="text-center">
      <p v-if="!hideInstructions" class="mb-3">
        Drop your file here to upload
        <br />OR
        <br />
      </p>
      <button type="button" class="btn btn-primary">Choose File</button>
      <p v-if="!hideMaxUpload" class="m-0">
        <br />
        Maximum upload file size: {{ maxUpload }}
      </p>
    </div>
    <div class="dropzone-preview mt-3"></div>
  </div>
</template>

<script>
import Dropzone from "dropzone";
export default {
  props: {
    id: { type: String, default: "dz-asset-uploader" },
    uploadUrl: { type: String, default: null },
    hideInstructions: { type: Boolean, default: false },
    hideMaxUpload: { type: Boolean, default: false },
    maxUpload: { type: String, default: "" },
  },
  data() {
    return {
      error: null,
    };
  },
  mounted() {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    Dropzone.autoDiscover = false;

    this.dropzone = new Dropzone(`#${this.id}`, {
      url: this.uploadUrl || this.route("admin.assets.upload"),
      paramName: "file",
      withCredentials: true,
      headers: { "X-CSRF-Token": token.content },
      clickable: `#${this.id} button`,
      previewsContainer: `#${this.id} .dropzone-preview`,
      hiddenInputContainer: `#${this.id} .dropzone-preview`,
      thumbnailMethod: "contain",
    });

    this.dropzone.on("success", (file, response) => {
      this.$emit("uploaded", file, response);
      setTimeout(() => {
        this.dropzone.removeFile(file);
      }, 3000);
    });

    this.dropzone.on("error", (file, response) => {
      this.error = response;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "sass/_variables";
.dropzone {
  background: transparent;
  border: 4px dashed $gray-500;
  margin-top: 1rem;
  margin-bottom: 3rem;
  min-height: 0;
  position: relative;
}
</style>